module.exports = __webpack_public_path__ + "media/images/icon__deleteMember-a21fdc194bec2e88e915bb7b7dc9c778.png";